import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../Assets/code.png'


const Navbar = () => {
    
        const location = useLocation()
        
    const navItems = <>
        <li className='mx-2'> <Link to={`/`}>Home</Link> </li>
        <li className='mx-2'> <Link to={`/about`}>About</Link> </li>
        <li className='mx-2'> <Link to={`/projects`}>Projects</Link> </li>
        <li className='mx-2'> <a target='blank' href={`https://samiul-dev-components.netlify.app/`}>Components</a> </li>
        <li className='mx-2'> <Link to={`/blog`}>Blog</Link> </li>
    
    </>
    return (
        <div className="container m-auto sticky top-0 z-30 bg-base-100">
            <div className="navbar text-white  ">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {navItems}
                    </ul>
                </div>
                <div className="flex">
                    <img src={logo} alt="" className="w-12" />
                    <Link to={`/`} className="btn btn-ghost normal-case text-xl">SAMIUL</Link>
                </div>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal px-1">
                    {navItems}
                </ul>
            </div>
            <div className="navbar-end">
                <Link to={`/contact`} className="btn btn-primary rounded-none btn-outline">Contact</Link>
            </div>
        </div>
        </div>
    );
};

export default Navbar;